import {
  Driver as DriverFromApi,
  DriverCreate,
  DriverDetail as DriverDetailFromApi,
  DriverUpdate,
} from "../../api";
import { Driver, DriverForm } from "../../types";

export const driversCreateToExternal = (entry: DriverForm): DriverCreate => ({
  first_name: entry.firstName,
  last_name: entry.lastName,
  personal_code: entry.personalCode,
  phone: entry.phone,
  email: entry.email,
  company_id: entry.companyId || undefined,
  manager_id: entry.managerId || undefined,
  vehicle_ids: entry.vehicleIds || [],
});

export const driversUpdateToExternal = (
  entry: Partial<DriverForm>,
): DriverUpdate => ({
  first_name: entry.firstName,
  last_name: entry.lastName,
  personal_code: entry.personalCode,
  phone: entry.phone,
  email: entry.email,
  company_id: entry.companyId || null,
  manager_id: entry.managerId || null,
  vehicle_ids: entry.vehicleIds || [],
  // defaults
});

const isDriverDetail = (
  entry: DriverFromApi | DriverDetailFromApi,
): entry is DriverDetailFromApi => "deliveries" in entry;

export const driversFromExternalList = (
  entry: DriverFromApi | DriverDetailFromApi,
): Driver => {
  return {
    id: entry.id,
    driverId: entry.id,
    firstName: entry.first_name,
    lastName: entry.last_name,
    personalCode: entry.personal_code,
    phone: entry.phone,
    email: entry.email ?? "",
    company: entry.company,
    companyId: entry.company_id,
    manager: entry.manager,
    managerId: entry.manager_id,
    trucks: entry.vehicles
      .filter((vehicle) => vehicle.type === "truck")
      .map((vehicle) => vehicle.number),
    trucksIds: entry.vehicles
      .filter((vehicle) => vehicle.type === "truck")
      .map((vehicle) => vehicle.id),

    trailers: entry.vehicles
      .filter((vehicle) => vehicle.type === "trailer")
      .map((vehicle) => vehicle.number),

    trailersIds: entry.vehicles
      .filter((vehicle) => vehicle.type === "trailer")
      .map((vehicle) => vehicle.id),

    deliveries: isDriverDetail(entry) ? (entry.deliveries ?? []) : [],
    commentsCount: entry.comments_count,
  };
};
